import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import moment from "moment";
import { useEffect, useState } from "react";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { useNavigate } from "react-router-dom";

interface CoinPaymentModalProps extends modalProps {
  livedate: string;
  live_start: Date;
  live_finish: Date;
  live_title: string;
  live_img: string;
  live_limit: number;
  secret_yn: boolean;
}

const CoinPaymentModal = ({
  visible,
  handleModal,
  livedate,
  live_start,
  live_finish,
  live_title,
  live_img,
  live_limit,
  secret_yn,
}: CoinPaymentModalProps) => {
  const closeModal = () => {
    handleModal();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const Navigate = useNavigate();
  const [useCoin, setUseCoin] = useState(0);
  const [myCoin, setMyCoin] = useState(60000);

  const stockCoin = async () => {
    const res = await api.get(url.Communication_url.stock_coin);
    setMyCoin(res.data.coin);
  };

  useEffect(() => {
    const duration =
      moment(live_finish).diff(moment(live_start), "hours") || 24;
    setUseCoin(live_limit * amountFormat(duration) * 3.8 * 1.2);
    stockCoin();
  }, [live_finish, live_start, live_limit]);

  const createLive = async () => {
    if (myCoin >= useCoin) {
      try {
        const res = await api.post(url.Communication_url.create_live, {
          live_start,
          live_finish,
          live_limit,
          live_title,
          live_img,
          secret_yn: secret_yn ? "y" : "n",
          log_type: "사용",
          log_con: "라이브 예약",
          coin: useCoin,
        });
        if (res.data === "성공") {
          alert("결제 완료");
          Navigate("/admin/livelist");
        }
      } catch (error) {
        console.error("실패:", error);
      }
    }
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          <RowView>
            <div>타이틀</div>
            <Icon
              className="btn"
              onClick={handleModal}
              src={require("../../../../Image/ic_closeX.png")}
            />
          </RowView>
        </Title>
        <ContentDiv>
          <RowView style={{ gap: 10 }}>
            <div>예약 일자</div>
            <div className="black">{moment(livedate).format("YYYY.MM.DD")}</div>
          </RowView>
          <RowView style={{ gap: 10 }}>
            <div>방송 시간</div>
            <div className="black">
              {amountFormat(
                moment(live_finish).diff(moment(live_start), "hours") || 24
              )}
              시간
            </div>
          </RowView>
          <RowView style={{ gap: 10 }}>
            <div>수용 인원</div>
            <div className="black">{amountFormat(live_limit)}명</div>
          </RowView>
          <Bar />
          <RowView style={{ width: "100%" }}>
            <div className="black">총 결제 코인</div>
            <div className="usecoin">{amountFormat(useCoin)}C</div>
          </RowView>
          <div className="mycoin">보유 코인 : {amountFormat(myCoin)}C</div>
        </ContentDiv>
        <BtnDiv>
          <ApplyBtn
            disabled={myCoin < useCoin}
            style={{
              cursor: myCoin >= useCoin ? "pointer" : "not-allowed",
              opacity: myCoin >= useCoin ? 1 : 0.5,
            }}
            onClick={createLive}
          >
            결제하기
          </ApplyBtn>
        </BtnDiv>
        {myCoin < useCoin && (
          <RedText>보유 코인이 부족합니다. 충전 후 다시 이용해주세요.</RedText>
        )}
      </ModalBox>
    </Container>
  );
};
export default CoinPaymentModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 95%;
  max-width: 25rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 24px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  margin-top: 5px;
`;

const ContentDiv = styled.div`
  padding: 20px 8px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: #8e8e8e;
  gap: 10px;
  div.black {
    color: black;
    font-family: var(--font-Pretendard-Medium);
  }
  div.usecoin {
    color: red;
    font-family: var(--font-Pretendard-SemiBold);
    font-size: 20px;
  }
  div.mycoin {
    font-size: 14px;
    color: #8e8e8e;
    align-self: flex-end;
    margin-bottom: 5px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.button`
  border-radius: 8px;
  height: 48px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  cursor: pointer;
  border: none;
`;

const ApplyBtn = styled(Btn)<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(135deg, #f5f5f5, #f5f5f5)"
      : "linear-gradient(135deg, #7955f0, #3209b9)"};
  color: ${({ disabled }) => (disabled ? "#000000" : "white")};
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8e8;
  margin: 5px 0px;
`;

const RedText = styled.div`
  font-size: 14px;
  color: red;
  text-align: center;
  margin-top: 10px;
`;
